/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable-next-line jsx-a11y/label-has-associated-control */
import React from "react";
import PropTypes from "prop-types";
import { useTable, useSortBy, useRowSelect } from "react-table";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Kebabs from "../../assets/img/icons/icon-kebabs-black.svg";
import SortUnsorted from "../../assets/img/icons/sort_unsorted.svg";
import SortUp from "../../assets/img/icons/sort_up.svg";
import SortDown from "../../assets/img/icons/sort_down.svg";
import EventLineItem from "./EventLineItem";

const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return (
      <>
        <label className="checkbox_container">
          <input type="checkbox" ref={resolvedRef} {...rest} />
          <span className="checkmark" />
        </label>
      </>
    );
  },
);

IndeterminateCheckbox.propTypes = {
  indeterminate: PropTypes.bool.isRequired,
};

function CommunicationsTable({
  columns,
  data,
  updateTrigger,
  updateTriggerBulk,
}) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        hiddenColumns: ["id", "longDescription", "activityEventName"],
      },
    },
    useSortBy,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((tableColumns) => [
        {
          id: "selection",
          width: 5,
          Header: ({ getToggleAllRowsSelectedProps }) => (
            <div>
              <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
            </div>
          ),
          Cell: ({ row }) => (
            <div>
              <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
            </div>
          ),
        },
        ...tableColumns,
      ]);
    },
  );

  const [dropdownOpen, setDropdownOpen] = React.useState(false);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const setActiveBulk = React.useCallback(
    (e) => {
      e.preventDefault();

      return updateTriggerBulk({
        ids: selectedFlatRows.map((d) => d.original.id),
        value: "1",
      });
    },
    [selectedFlatRows, updateTriggerBulk],
  );

  const setInActiveBulk = React.useCallback(
    (e) => {
      e.preventDefault();

      return updateTriggerBulk({
        ids: selectedFlatRows.map((d) => d.original.id),
        value: "0",
      });
    },
    [selectedFlatRows, updateTriggerBulk],
  );

  return (
    <div className="pp_comms_parent">
      <div {...getTableProps()} className="pp_comms_table">
        <div className="pp_comms_table__selector">
          {`${selectedFlatRows.length} selected out of ${data.length}`}

          <Dropdown isOpen={dropdownOpen} toggle={toggle}>
            <DropdownToggle>
              <Kebabs className="pp_comms_kebab" />
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem header>Bulk Action</DropdownItem>
              <DropdownItem onClick={setActiveBulk}>
                Set Selected to Active
              </DropdownItem>
              <DropdownItem onClick={setInActiveBulk}>
                Set Selected to Inactive
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
        {headerGroups.map((headerGroup, index) => (
          <div
            {...headerGroup.getHeaderGroupProps()}
            key={index}
            className="pp_comms_table__header"
          >
            {headerGroup.headers.map((column, columnIndex) => {
              return (
                <div
                  key={columnIndex}
                  className={`pp_comms_table__header_name pp_comms_table__header_name--${
                    typeof column.Header === "string"
                      ? column.Header.toLowerCase()
                      : ""
                  }`}
                >
                  <div className="pp_comms_table__sorting_parent">
                    <span
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      className="pp_comms_table__header_span"
                    >
                      {column.displayName || column.render("Header")}
                      <span className="pp_comms_table__header_span">
                        {column.isSorted ? (
                          column.isSortedDesc ? (
                            <SortUp className="pp_comms_table__sort_icon" />
                          ) : (
                            <SortDown className="pp_comms_table__sort_icon" />
                          )
                        ) : (
                          <SortUnsorted className="pp_comms_table__sort_icon" />
                        )}
                      </span>
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        ))}
        <div {...getTableBodyProps()}>
          {rows.map((row, index) => {
            prepareRow(row);
            return (
              <EventLineItem
                key={index}
                row={row}
                updateTrigger={updateTrigger}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}

CommunicationsTable.propTypes = {
  updateTrigger: PropTypes.func.isRequired,
  updateTriggerBulk: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.string,
      shortDescription: PropTypes.string,
      longDescription: PropTypes.string,
      smartFields: PropTypes.arrayOf(PropTypes.string),
      templateName: PropTypes.string,
      isActive: PropTypes.bool,
    }),
  ).isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      Header: PropTypes.string,
      accessor: PropTypes.string,
    }),
  ).isRequired,
  getToggleAllRowsSelectedProps: PropTypes.func,
  row: PropTypes.shape({
    getToggleRowSelectedProps: PropTypes.func,
  }),
};

CommunicationsTable.defaultProps = {
  getToggleAllRowsSelectedProps: () => {},
  row: {
    getToggleRowSelectedProps: () => {},
  },
};

export default CommunicationsTable;
